"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _categoryBanners = _interopRequireDefault(require("@deosite/helpers/prismicDataMapper/categoryBanners"));
var _cache = require("@deosite/helpers/cache");
var _prismicHelper = require("../prismicHelper");
var _prismicErrorHandle = _interopRequireDefault(require("@deosite/helpers/prismicErrorHandle"));
var filename = "categorybanners";
var fetcher = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(language) {
    var _yield$getLanguage, cacheFileExist, cachedRequest, lang, cacheFilePath, response, mappedCategoryBanners, _yield$getLanguage2, _cacheFileExist, _cachedRequest;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _prismicHelper.getLanguage)({
              language: language,
              filename: filename
            });
          case 2:
            _yield$getLanguage = _context.sent;
            cacheFileExist = _yield$getLanguage.cacheFileExist;
            cachedRequest = _yield$getLanguage.cachedRequest;
            lang = _yield$getLanguage.lang;
            cacheFilePath = _yield$getLanguage.cacheFilePath;
            if (!cacheFileExist) {
              _context.next = 9;
              break;
            }
            return _context.abrupt("return", cachedRequest);
          case 9:
            _context.prev = 9;
            _context.next = 12;
            return (0, _prismicHelper.getResponsePrismicByUID)({
              type: filename,
              uid: global.__appConfig__.prismicCategoryBanners,
              lang: lang
            });
          case 12:
            response = _context.sent;
            mappedCategoryBanners = (0, _categoryBanners["default"])(response);
            _context.next = 16;
            return (0, _cache.saveCacheFile)({
              cacheFilePath: cacheFilePath,
              filenameCategoryCache: "".concat(filename, ".json"),
              result: mappedCategoryBanners
            });
          case 16:
            return _context.abrupt("return", mappedCategoryBanners);
          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](9);
            _context.next = 23;
            return (0, _prismicHelper.getLanguage)({
              language: language,
              filename: filename
            });
          case 23:
            _yield$getLanguage2 = _context.sent;
            _cacheFileExist = _yield$getLanguage2.cacheFileExist;
            _cachedRequest = _yield$getLanguage2.cachedRequest;
            if (!_cacheFileExist) {
              _context.next = 28;
              break;
            }
            return _context.abrupt("return", _cachedRequest);
          case 28:
            return _context.abrupt("return", (0, _prismicErrorHandle["default"])(_context.t0, "Prismic - category banners - ".concat(_context.t0)));
          case 29:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[9, 19]]);
  }));
  return function fetcher(_x) {
    return _ref.apply(this, arguments);
  };
}();
var _default = fetcher;
exports["default"] = _default;